<template>

  <div class="news">

   <pre-post v-if="posts" :media="proxyUrl + posts[0].jetpack_featured_media_url" :post="posts[0]"></pre-post>
    <div class="news_body">
      <div class="container">

        <div class="row">
          <!-- BODY PAGE -->
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-12">
                <div class="posts_section">
                  <div class="page_section_header">
                    <h2 class="sc">
                      {{type}}

                    </h2>
                    <p v-if="type =='blog'">
                   Blogging isn’t just about publishing random words; it’s about unleashing creativity into the universe. Because we’re huge supporters of unleashing creativity, we’ve creating the most exciting blogs just for you. Enjoy!

                    </p>
                    <p v-else>
                   The more you read about the world around you, the more you're connected to the world. Get the latest news from around the world all in one place and start connecting today!

                    </p>
                  </div>
                  <div class="page_section_body" v-if="posts_cat">
                    <!-- POST STYLE -->
                    <post data-aos="fade-up" data-aos-delay="100" data-aos-once="true"
                      v-for="item in posts_cat.slice(0,visibleItems)" :post="item" :key="item.id" :categories="categories" :media="medias">
                    </post>
                    <!--End POST STYLE -->
                    <button @click="showMore" v-if="visibleItems <= posts_cat.length " class=" button button--transparent-grad pulse">
                      <span>
                        Show more
                      </span>
                    </button>

                  </div>
                </div>

              </div>

            </div>

          </div>

          <!-- SIDE PAGE -->
          <div class="col-md-3 col-xs-12">
            <side-bare></side-bare>
          </div>
        </div>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
  import GPost from '@/mixins/posts';
  import global from '@/mixins/global';
  import axios from 'axios';

  export default {
    mixins: [global,GPost],

    data() {
      return {
        posts_cat: undefined,
        visibleItems: 4,
        type :undefined,
      }
    },
   async created() {
     await this.getCategories();
     await this.getPosts_cat();
    },

    methods: {
     async getPosts_cat() {
        var $this = this;
        this.type =  this.$route.params.id;
        var url = this.proxyUrl +'http://news.mobilityintel.com/wp-json/wp/v2/posts/?categories=2&per_page=100';
        if( this.type =="blog"){
         url = this.proxyUrl +'http://news.mobilityintel.com/wp-json/wp/v2/posts/?categories=3&per_page=100';
        }
      return axios.get(url , {
            headers: {
              'Content-Type': 'application/json'
            }
          }, ).then(function (response) {
            
            $this.posts_cat = response.data;
          })
          .catch(function (error) {
          });
      },
  
      getCategoryById(id) {
        return this.categories.filter(
          function (data) {
            return data.id == id
          });
      },
      showMore() {
        this.visibleItems += 4;
      }
    },


  }

</script>

<style lang="scss">
  .news {
    @import "../../../assets/style/flexbox";
  }

  @import "../style";

  .posts_section {
    margin-right: 31px;
  }
.sc {
    text-transform: capitalize;
}
</style>
<style scoped>
  .date_icon {
    display: block;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/News/NewsPage/index.vue